import { FUNDS } from 'common/constants/user';
import * as FUND_DIALOG_FORM_CONSTANTS from './fundDialogForm';
import * as FUND_SUMMARY_CONSTANTS from './fundSummary';
import * as SCHEDULE_OF_INVESTMENTS_CONSTANTS from './scheduleOfInvestments';
import * as VALUATIONS_SUMMARY_CONSTANTS from './valuationsSummary';

export {
  FUND_DIALOG_FORM_CONSTANTS,
  FUND_SUMMARY_CONSTANTS,
  SCHEDULE_OF_INVESTMENTS_CONSTANTS,
  VALUATIONS_SUMMARY_CONSTANTS,
};

export const FUNDS_CONTAINER_CLASSNAME = `${FUNDS}-container`;
